import { useState, useEffect } from 'react'
import { adminAPI } from '../../services/api'

export default function CampaignCategoriesPanel() {
  const [cats, setCats] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(null)
  const [msg, setMsg] = useState(null)
  const [nuevo, setNuevo] = useState({ name: '', color: '#6366f1', cooldown_days: 365 })

  const load = () => adminAPI.getCampaignCategories()
    .then(d => setCats(d.categories || []))
    .catch(() => setMsg('Error al cargar'))
    .finally(() => setLoading(false))
  useEffect(() => { load() }, [])

  function edit(id, field, value) {
    setCats(prev => prev.map(c => c.id === id ? { ...c, [field]: value } : c))
  }

  async function save(c) {
    setSaving(c.id); setMsg(null)
    try {
      const days = Math.min(3650, Math.max(1, parseInt(c.cooldown_days, 10) || 365))
      await adminAPI.updateCampaignCategory(c.id, { name: c.name, color: c.color, cooldown_days: days, is_active: c.is_active })
      setMsg('Guardado ✓'); load()
    } catch (e) { setMsg(e.response?.data?.error || 'Error al guardar') } finally { setSaving(null) }
  }

  async function crear() {
    if (!nuevo.name.trim()) return
    setSaving('new'); setMsg(null)
    try {
      const days = Math.min(3650, Math.max(1, parseInt(nuevo.cooldown_days, 10) || 365))
      await adminAPI.createCampaignCategory({ name: nuevo.name.trim(), color: nuevo.color, cooldown_days: days })
      setNuevo({ name: '', color: '#6366f1', cooldown_days: 365 }); setMsg('Creada ✓'); load()
    } catch (e) { setMsg(e.response?.data?.error || 'Error al crear') } finally { setSaving(null) }
  }

  if (loading) return <div className="p-6 text-sm text-gray-500">Cargando…</div>

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h2 className="text-lg font-medium mb-1">Categorías de campaña</h2>
      <p className="text-sm text-gray-500 mb-4">Cada categoría impide reinscribir al mismo prospecto en otra campaña de la misma categoría durante su ventana (días).</p>

      <div className="flex items-center gap-3 px-1 pb-2 border-b border-gray-200 dark:border-gray-700 text-xs text-gray-400">
        <span className="w-8"></span>
        <span className="flex-1">Nombre</span>
        <span className="w-28 text-center">Cooldown (días)</span>
        <span className="w-16 text-center">Activa</span>
        <span className="w-20"></span>
      </div>

      {cats.map(c => (
        <div key={c.id} className="flex items-center gap-3 px-1 py-2 border-b border-gray-100 dark:border-gray-800">
          <input type="color" value={c.color || '#6366f1'} onChange={e => edit(c.id, 'color', e.target.value)} className="w-8 h-8 rounded cursor-pointer border-0 bg-transparent" />
          <input value={c.name} onChange={e => edit(c.id, 'name', e.target.value)} className="flex-1 text-sm bg-transparent border border-gray-200 dark:border-gray-700 rounded px-2 py-1" />
          <input type="number" min="1" max="3650" value={c.cooldown_days} onChange={e => edit(c.id, 'cooldown_days', e.target.value)} className="w-28 text-sm text-center bg-transparent border border-gray-200 dark:border-gray-700 rounded px-2 py-1" />
          <label className="w-16 flex justify-center">
            <input type="checkbox" checked={!!c.is_active} onChange={e => edit(c.id, 'is_active', e.target.checked)} className="w-4 h-4" />
          </label>
          <button onClick={() => save(c)} disabled={saving === c.id} className="w-20 px-2 py-1 text-xs bg-primary-600 text-white rounded hover:bg-primary-700 disabled:opacity-50">
            {saving === c.id ? '…' : 'Guardar'}
          </button>
        </div>
      ))}

      <div className="flex items-center gap-3 px-1 py-3 mt-2 border-t border-gray-200 dark:border-gray-700">
        <input type="color" value={nuevo.color} onChange={e => setNuevo(v => ({ ...v, color: e.target.value }))} className="w-8 h-8 rounded cursor-pointer border-0 bg-transparent" />
        <input value={nuevo.name} onChange={e => setNuevo(v => ({ ...v, name: e.target.value }))} placeholder="Nueva categoría" className="flex-1 text-sm bg-transparent border border-gray-200 dark:border-gray-700 rounded px-2 py-1" />
        <input type="number" min="1" max="3650" value={nuevo.cooldown_days} onChange={e => setNuevo(v => ({ ...v, cooldown_days: e.target.value }))} className="w-28 text-sm text-center bg-transparent border border-gray-200 dark:border-gray-700 rounded px-2 py-1" />
        <span className="w-16"></span>
        <button onClick={crear} disabled={saving === 'new'} className="w-20 px-2 py-1 text-xs bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-50">
          {saving === 'new' ? '…' : 'Crear'}
        </button>
      </div>

      {msg && <div className="mt-3 text-xs text-gray-500">{msg}</div>}
    </div>
  )
}
